import type { RemirrorJSON } from '@remirror/core';
import type { ChatMention } from '@trinity/chat';

export function extractMentionsFromDoc(doc: RemirrorJSON): ChatMention[] {
  const mentions: ChatMention[] = [];

  function walk(node: RemirrorJSON): void {
    if (node.type === 'mentionAtom' && node.attrs) {
      mentions.push({
        entityId: String(node.attrs['id']),
        name: String(node.attrs['label']),
        type: String(node.attrs['entityType'] ?? ''),
        objectId: node.attrs['objectId'] != null ? String(node.attrs['objectId']) : undefined,
        link: node.attrs['link'] != null ? String(node.attrs['link']) : undefined,
      });
    }
    for (const child of node.content ?? []) {
      walk(child);
    }
  }

  walk(doc);
  return mentions;
}
